import { defineComponent as _defineComponent } from 'vue'
import {
  computed, nextTick, onMounted, Ref, ref, watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import MapTilerSearchResults from '@/components/MapTilerSearchResults.vue';
import { MaptilerGeoSearchResponse } from '~model';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapTilerSearch',
  setup(__props) {

const { getters } = store;

const input = ref() as Ref<HTMLInputElement>;
const showSuggestions = ref(true);
const focusedInput = ref(false);
const focusedSuggestions = ref(false);
const autoSelectSuggestion = ref(true);
const delay = ref(700);
const search = ref('');
const timeout = ref(0);

const route = useRoute();
const router = useRouter();
function blurInput() {
  input.value.blur();
  focusedInput.value = false;
}

function blurSuggestions() {
  focusedSuggestions.value = false;
}

function hideSuggestions() {
  showSuggestions.value = false;
  setTimeout(() => {
    showSuggestions.value = true;
  }, 100);
}

function focusInput() {
  input.value.focus();
  focusedInput.value = true;
  focusedSuggestions.value = false;
}

function updateSearchQuery() {
  if (route.query.search !== search.value) {
    router.replace({ query: { ...route.query, search: search.value } });
  }
}

function handleSearchQuery() {
  search.value = route?.query?.search as string;
  focusInput();
}

function selectSuggestion(
  suggestion: MaptilerGeoSearchResponse['features'][0],
): void {
  const { center } = suggestion;
  const lat = center[0];
  const lon = center[1];

  getters
    .getMap
    .easeTo({
      center: [lat, lon],
      zoom: 8,
      duration: 2000,
    });

  search.value = suggestion.text;

  updateSearchQuery();
  blurInput();
  blurSuggestions();
  hideSuggestions();
  autoSelectSuggestion.value = false;
}

watch(search, (word) => {
  clearTimeout(timeout.value);

  timeout.value = setTimeout(() => {
    store.state.region.search = word;
    if (word.length > 2) {
      store.dispatch('fetchGeoCoding');
    }
  }, delay.value);
});

const searchResponse = computed((): MaptilerGeoSearchResponse => getters.getSearchResponse);

function autoSelectFirstSuggestion() {
  if (searchResponse.value.features.length > 0) {
    selectSuggestion(searchResponse.value?.features[0]);
    document.querySelector('#shop-wall')?.scrollIntoView({ behavior: 'smooth' });
  }
}

watch(
  searchResponse,
  (response) => {
    if (response && autoSelectSuggestion.value && route.query.search) {
      nextTick(autoSelectFirstSuggestion());
    }
  },
);

onMounted(() => {
  if (route.query.search) {
    handleSearchQuery();
  }
});

return { __sfc: true,getters, input, showSuggestions, focusedInput, focusedSuggestions, autoSelectSuggestion, delay, search, timeout, route, router, blurInput, blurSuggestions, hideSuggestions, focusInput, updateSearchQuery, handleSearchQuery, selectSuggestion, searchResponse, autoSelectFirstSuggestion, MapTilerSearchResults }
}

})